import React, { useRef } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import CategoryChecbox from './CategoryChecbox';
import { ErrorMessage } from '@hookform/error-message';

const CollectInfo = () => {
  const { getValues, control, formState: { errors } } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'collectInfo',
  });
  const inputEl = useRef(null);

  const addCustomCategory = () => {
    const value = inputEl.current.value;
    if (!value || value.trim().length === 0) return;
    append({
      id: `custom-${Date.now()}`,
      label: value,
      value: true,
      retentionPeriod: '',
      legalBasis: '',
      subcategories: [],
      isCustomSubcategories: false,
      customSubcategories: [],
      whatWeCollect: '',
      purpose: '',
      isCustom: true,
    });
    inputEl.current.value = '';
  };

  return (
    <div>
      {fields.map((field, index) => (
        <CategoryChecbox
          key={field.id}
          index={index}
          field={field}
          onRemoveCustom={() => {
            if (field.isCustom) remove(index);
          }}
        />
      ))}
      <div className='input-group w-50 mt-2 mb-2'>
        <input ref={inputEl} type='text' className='form-control' placeholder='Add more...' />
        <button className='btn btn-success' type='button' onClick={addCustomCategory}>
          <i className='fas fa-plus' />
        </button>
      </div>
      <ErrorMessage
        errors={errors}
        name="collectInfo"
        render={({ message }) => <div className="text-danger">{message}</div>}
      />
    </div>
  );
};

export default CollectInfo; 